import { render, staticRenderFns } from "./PlatformRight.vue?vue&type=template&id=51d5e225&scoped=true"
import script from "./PlatformRight.vue?vue&type=script&lang=js"
export * from "./PlatformRight.vue?vue&type=script&lang=js"
import style0 from "./PlatformRight.vue?vue&type=style&index=0&id=51d5e225&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d5e225",
  null
  
)

export default component.exports